<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content">
          <h3>Supervisão</h3>
          <p>O Espaço Winnicott Brasília oferece supervisão clínica a quem já exerce a psicologia dentro da clínica. As supervisões podem ser individuais ou em grupo.</p>
        
        </div>
        <h3 class="is-size-4"></h3>
        <p class=""></p>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuemSomos',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
